/* eslint-disable import/no-mutable-exports */
export let $window;
export let $doc;
export let $body;
export let _contextOnePage;
export let _sammy;
export const _enteRef = '06a3d9f1-ccf9-4d16-8302-b65572bf4aab';
export let _videoPlayer;
export let _loadingInProgress;
export let _didScroll;
export let _scrollTimer;
export const _viewPage = 0;
export const _itemsToDisplay = 10;
export const directioCMSapiService = 'http://directio.it/base/';
export const _monthNames = ['Gennaio', 'Febraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
export const _monthShortNames = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
export const breakpointsPixels = [768, 992, 1200];
export let _flexSlider;
export const _GetParams = {};
export const editionUpdateEndpoint = 'http://help.directio.it/Umbraco/Api/NewsApi/GetAllNews';
export let bannerNewsSchedule;
let webApiServiceDomain = 'http://apis.directio.it/';
if (__DEV__) {
	webApiServiceDomain = 'http://apis.directio.it/';
}
export const _webApiServiceDomain = webApiServiceDomain;



/** WEBPACK FOOTER **
 ** ./Scripts/libs/variables.js
 **/